import React, { memo } from "react";
import { useRecoilValue } from "recoil";

import { simulationAmountState } from '../../../store/simulationAmountState';

export const ConfirmInfo = memo(() => {
  const simulationAmountData = useRecoilValue(simulationAmountState);
  
  return (
    <>
      <div className="card mb-3">
        <div className="card-header text-danger">
          【注意事項】
        </div>
        {simulationAmountData.loading ?
          <div className="card-body">
            <p>
              {simulationAmountData.message}
              <br />
              ※金額は、概算になりますのでご了承ください。（巡回健診は金額の計算は行いません。）
            </p>
            <div className="mt-3">
              <p>
                <span className="fw-bold text-danger">自己負担金額</span>：
                &#xFFE5; {simulationAmountData.result_price}
              </p>
              {simulationAmountData?.cource_type != 0 &&
                <p>
                  <span className="fw-bold">会社補助金額：</span>
                  &#xFFE5; {simulationAmountData.funding_price}
                </p>
              }
              <p>
                <span className="fw-bold">申込内容金額：</span>
                &#xFFE5; {simulationAmountData.calc_price}
              </p>
            </div>
          </div>
        :
          <div className="card-body">
            Calculating ...
          </div>
        }
      </div>
    </>
  );
});